export default "__VITE_ASSET__CrIQ$sDt__"